<script setup>
import { router } from "@inertiajs/vue3";
import ActionButton from "@js/components/ActionButton.vue";
import Modal from "@js/components/Modal.vue";
import ComboboxField from "@js/components/fields/ComboboxField.vue";
import { useRoute } from "@js/utils/route";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { tenants } = defineProps({
  tenants: {
    type: Array,
    required: true,
  },
});

const { route } = useRoute();

const tenant = ref(tenants[0]);

const createButtonRef = ref(null);

const isOpen = ref(false);

function setIsOpen(value) {
  isOpen.value = value;
}

function action() {
  router.visit(
    route("front.projectManagement.sem.shortMessageService", { tenant: tenant.value.id }),
  );
}
</script>

<template>
  <slot name="button" :set-is-open="setIsOpen" />

  <Modal
    :is-open="isOpen"
    :set-is-open="setIsOpen"
    size="small"
    :initial-focus="createButtonRef"
  >
    <template #title>
      {{ t("title.createSms") }}
    </template>

    <template #content>
      <div class="min-h-96">
        <ComboboxField
          v-model="tenant"
          :options="tenants"
          :label="t('label.customerName')"
          field-name="tenant"
          field-id="tenant"
          filteredOptionKey="name"
        >
          <template #optionContent="{ option }">
            {{ option.name }}
          </template>
        </ComboboxField>
      </div>
    </template>

    <template #footer>
      <div class="flex justify-end gap-2">
        <ActionButton type="transparent" :callback="() => setIsOpen(false)">
          {{ t("button.cancel") }}
        </ActionButton>

        <ActionButton ref="createButtonRef" :callback="action">
          {{ t("button.create") }}
        </ActionButton>
      </div>
    </template>
  </Modal>
</template>
